<script lang="ts" setup>
const { class: className } = defineProps<{
	class?: any;
}>();
</script>

<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="none"
		class="size-10 animate-spin text-default"
		:class="[className]"
	>
		<path
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1"
			d="M21 12a9 9 0 1 1-6.219-8.56"
		/>
	</svg>
</template>
